/* ============================================================
   Pending-Writes-Tracker
   ----------------------
   Zentrales Set offener Schreibvorgänge. Repos rufen `track(label, fn)`,
   wir registrieren die Operation, führen sie aus und entfernen sie wieder.
   Nutzen:
     - `beforeunload`-Warnung, falls beim Schließen noch Saves laufen
     - Optional: globaler "Speichern…"-Indikator (UI lesen via subscribe)
   ============================================================ */

const _pending = new Map()        // id → label
const _listeners = new Set()
let _seq = 0

function emit() {
  _listeners.forEach(fn => {
    try { fn(snapshot()) } catch { /* listener fehler ignorieren */ }
  })
}

export function snapshot() {
  return {
    count: _pending.size,
    labels: Array.from(_pending.values()),
  }
}

export function subscribe(fn) {
  _listeners.add(fn)
  return () => _listeners.delete(fn)
}

export function isBusy() {
  return _pending.size > 0
}

/* Führt `fn` aus und registriert sie als pending. Gibt das Ergebnis von fn zurück.
   Bei Fehler: Eintrag wird ebenfalls entfernt, Fehler propagiert. */
export async function track(label, fn) {
  const id = ++_seq
  _pending.set(id, label)
  emit()
  try {
    return await fn()
  } finally {
    _pending.delete(id)
    emit()
  }
}

/* Einmaliges Setup: Browser-Warnung, falls Saves noch laufen. */
let _installed = false
export function installBeforeUnloadGuard() {
  if (_installed) return
  _installed = true
  window.addEventListener('beforeunload', e => {
    if (!isBusy()) return
    // Moderne Browser zeigen eigenen Text — preventDefault + returnValue genügt.
    e.preventDefault()
    e.returnValue = ''
    return ''
  })
}

// Auto-install — Modul wird einmal beim ersten Import initialisiert.
installBeforeUnloadGuard()
